const KEY = 'vgp_workspace_id';

export function getSelectedWorkspaceId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setSelectedWorkspaceId(id: string): void {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* Private browsing can make storage unavailable. */
  }
}

